import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import { useNavigate } from "react-router-dom";
import { updateMainHeader } from "../../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
import { useDispatch } from "react-redux";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import ConfirmationPopup from "../../../Components/Confirmation/Confirmation";
import { resetDataComponent } from "../../../StateManagement/actions";

export const BankList: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showMessage } = useSnackbar();

  const [selectedId, setSelectedId] = useState<string | number>(0);
  const [isPopupOpen, setPopupOpen] = useState(false);


  // Header
  useEffect(() => {
    updateMainHeader("Cheque Managment");
  }, []);

  // Breadcrumbs
  breadCrumbsStore.updateBreadCrumbs([
    { "Bank Details": "/bank/list" },
  ]);

  const source = {
    url: "banks/list",  // ✅ Fixed API path
    page: 1,
    pageSize: 10,
    filter: [],
    sort: [],
    type: 'GET' as const
  };




  const columns: IColumns[] = [
    { header: "Bank Name", fieldName: "BankName" },
    { header: "Branch", fieldName: "Branch" },
    { header: "Account Number", fieldName: "AccountNumber" },
    { header: "IFSC Code ", fieldName: "IFSC" },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: ["Edit", "Delete"],
      actionCallback: (action: string, row: any) => {
        console.log("🔍 Row data:", row);


        const BankId = row.BankId;
        if (!BankId) {
          console.error("❌ No valid ID found in row:", row);
          showMessage("Invalid bank data - missing ID", "error");
          return;
        }

        if (action === "Edit") {
          console.log("✏️ Navigating to edit:", BankId);
          navigate(`/bank/${BankId}`);
        } else if (action === "Delete") {
          console.log("🗑️ Delete clicked:", BankId);
          setSelectedId(BankId);
          setPopupOpen(true);
        }
      },
    },

  ];

  // Filters (UI only)


  const handleClick = () => {
    navigate("/bank");
  };

  return (
    <Grid p={3}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <WSDataGrid
            id="bankGrid"
            title="Bank Details "
            headerType="modern"
            columns={columns}
            source={source}
            rowsPerPageCount={10}
            searchBox={{ fieldName: "bankname" }}
            addButton={{ label: "Add New Bank", color: "secondary" }}
            onAddButtonClick={handleClick}
            
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke",
            }}
          />
        </Grid>
      </Grid>
      <ConfirmationPopup
        type="DELETE"
        apiUrl="banks"
        id={selectedId}
        confirmMessage="Are you sure you want to delete this bank?"
        open={isPopupOpen}
        onClose={() => setPopupOpen(false)}
        onConfirm={(data: any) => {
          dispatch(resetDataComponent("bankGrid"));
          if (data.success === true) {
            showMessage(data?.message, "success");
          } else {
           showMessage(data?.detail, "error");
          }
        }}
      />
    </Grid>
  );
};